const LAST_ROUTE_KEY = "oiLastOpenedRoute";
const LAST_ROUTE_PATTERN = /^\/Oi\/(eventReport|powderOrder|rawMaterialControl|analysisOrder|analysisResult)\/(?!new$|order\/)[^/]+$/i;

export function isRestorableOiRoute(pathname: string): boolean {
  return LAST_ROUTE_PATTERN.test(pathname);
}

export function getOiLastRoute(): string | null {
  const saved = window.localStorage.getItem(LAST_ROUTE_KEY);
  return saved && isRestorableOiRoute(saved) ? saved : null;
}

export function saveOiLastRoute(pathname: string): void {
  if (isRestorableOiRoute(pathname)) {
    window.localStorage.setItem(LAST_ROUTE_KEY, pathname);
  }
}

/** Forgets the saved route when it points to `pathname`, so a missing record is not reopened on next load. */
export function forgetOiLastRoute(pathname: string): void {
  if (window.localStorage.getItem(LAST_ROUTE_KEY)?.toLowerCase() === pathname.toLowerCase()) {
    window.localStorage.removeItem(LAST_ROUTE_KEY);
  }
}
